import { render, staticRenderFns } from "./default-page.vue?vue&type=template&id=0cbaaf3c&scoped=true&"
import script from "./default-page.vue?vue&type=script&lang=js&"
export * from "./default-page.vue?vue&type=script&lang=js&"
import style0 from "./default-page.vue?vue&type=style&index=0&id=0cbaaf3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbaaf3c",
  null
  
)

export default component.exports